import type { DailyTagCategory } from "@/pages/human-resources/time-management/business/daily-tag/DailyTagCategory.ts";
import {
  type DailyTagDuration,
  durationAsNbDays,
} from "@/pages/human-resources/time-management/business/daily-tag/DailyTagDuration.ts";
import type { DailyTagEquivalence } from "@/pages/human-resources/time-management/business/daily-tag/DailyTagEquivalence.ts";
import type { Contract } from "@/pages/human-resources/time-management/business/contract/Contract.ts";

export class DailyTag {
  constructor(
    public readonly id: string,
    public readonly category: DailyTagCategory,
    public readonly domainId: string | undefined,
    public readonly siteId: string | undefined,
    public readonly disabled: boolean,
    public readonly equivalence: DailyTagEquivalence,
    public readonly label: string,
    public readonly description: string,
    public readonly nbMeals: number,
    public readonly color: string | undefined,
    public readonly solo: boolean,
    public readonly defaultDurationMinutes: number | undefined,
    public readonly allowCustomDurationMinutes: boolean,
    public readonly durationDay: DailyTagDuration,
  ) {}

  public isFullDayOrSolo(): boolean {
    return this.solo || this.durationDay === "FULL";
  }

  public isWork(): boolean {
    return this.category === "PRESENCE";
  }

  public computeWorkDurationMinutes(contract: Contract): number {
    return this.isWork() ? this.computeValueMinutes(contract) : 0;
  }

  public computeValueMinutes(contract: Contract): number {
    if (this.defaultDurationMinutes !== undefined) {
      return this.defaultDurationMinutes;
    }
    if (contract.weeklyWorkingHours === undefined) {
      return 0;
    }
    return Math.round((contract.weeklyWorkingHours / 5) * this.nbDays() * 60);
  }

  private nbDays(): number {
    return durationAsNbDays(this.durationDay);
  }
}
